import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchCropField(agro_exporter_id, crop_field_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/list_templates/${agro_exporter_id}/crop_field/${crop_field_id}`
    );
  },
  downloadQualityInspectsRepXlsx({ agro_exporter_id, crop_field_id, quality_template_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/list_export_quality_inspects/${agro_exporter_id}/${crop_field_id}/${quality_template_id}/download_quality_inspects_rep_xlsx`,
      { responseType: "blob" }
    );
  },
  fetchExportQualityInspects(agro_exporter_id, crop_field_id, quality_template_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/list_export_quality_inspects/${agro_exporter_id}/${crop_field_id}/${quality_template_id}`
    );
  },
  fetchExporterQualityTemplate(agro_exporter_id, crop_field_id, quality_template_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/list_export_quality_inspects/${agro_exporter_id}/${crop_field_id}/quality_template/${quality_template_id}`
    );
  }
};
